import { createButtonMenu } from "./buttonMenu/buttonMenu"
import { CheckboxCtrl } from "./checkbox"
import { ColorPicker } from "./color-picker/cp"
import { ColorPickerButton } from "./color-picker/cp-button"
import { DatePickerCtrl } from "./datepicker/datepicker"
import { getDomEventFactory } from "./domEvent"
import { DialogCtrl } from "./files/dialog/dialog"
import { PathCtrl } from "./files/path/path"
import { SelectionCtrl } from "./files/selection/selection"
import { getFocusFactory } from "./focus"
import { getInputFileChangeFactory } from "./inputFileChange"
import { createMaxLines } from "./maxLines"
import { getModelPercentFactory } from "./modelPercent"
import { createModuleHeader } from "./moduleHeader/moduleHeader"
import { getPercentFilter } from "./percentFilter"
import { createPopupMenu } from "./popupMenu/popupMenu"
import { createRequiredDirective } from "./required"
import { createTableMenuDirective } from "./tablemenu/tablemenu"
import { defineTextFormatDirectives } from "./text"
import { getValueTextFilter } from "./valueTextFilter"
import { ViewSelect } from "./viewSelect/vs"
import { YearsPickerCtrl } from "./years/years"

export function setupComponents(module: ng.IModule) {

    module
        .directive("omniaTableMenu", createTableMenuDirective)
        .directive("omniaDatePicker", DatePickerCtrl.create)
        .directive("omniaCheckbox", CheckboxCtrl.create)
        .directive("omniaFocus", getFocusFactory())
        .directive("omniaRequired", createRequiredDirective)
        .directive("ngRightclick", getDomEventFactory("contextmenu", "ngRightclick", true))
        .directive("ngTouchstart", getDomEventFactory("touchstart", "ngTouchstart", false))

        .directive("omniaViewSelect", ViewSelect.create)

        .filter("omniaValueText", getValueTextFilter)
        .filter("omniaPercent", getPercentFilter)

        .directive("omniaModelPercent", getModelPercentFactory())

        .directive("omniaModuleHeader", createModuleHeader)
        .directive("omniaButtonMenu", createButtonMenu)
        .directive("omniaPopupMenu", createPopupMenu)

        .directive("omniaInputFileChange", getInputFileChangeFactory())

        .directive("omniaColorPicker", ColorPicker.create)
        .directive("omniaColorPickerButton", ColorPickerButton.create)

        .directive("omniaMaxLines", createMaxLines)

        .directive("omniaFilesDialog", DialogCtrl.create)
        .directive("omniaFilesSelection", SelectionCtrl.create)
        .directive("omniaFilesPath", PathCtrl.create)

        .directive("omniaYearsPicker", YearsPickerCtrl.create)

    defineTextFormatDirectives(module)

    return module

}
